import { BILLING_PRODUCT } from "../services/billing/billing.const"
import { getAddonFreeQuota, getAddonStripe, getAddonTier, isAddonFreeTier } from "./addon-plan"
import { isOrgEnterprise } from "./org-plan"

/**
 * Equipment add-on entitlement, read off the org document - the front door for the
 * Equipment add-on the way expenses-plan.js is for Expenses. Admin-only data (the org's
 * `equipment` field is only sent to admins); everyone else reads the cap from
 * GET /org/:id/equipment/capacity.
 *
 * Display only. The API refuses a piece over the cap (equipment/limit_reached).
 */

export const getEquipmentStripe = (orgData) => getAddonStripe(orgData, BILLING_PRODUCT.EQUIPMENT)

export const getEquipmentTier = (orgData) => getAddonTier(orgData, BILLING_PRODUCT.EQUIPMENT)

export const isEquipmentFreeTier = (orgData) => isAddonFreeTier(orgData, BILLING_PRODUCT.EQUIPMENT)

export const getEquipmentFreeQuota = (orgData) => getAddonFreeQuota(orgData, BILLING_PRODUCT.EQUIPMENT)

/**
 * The licence floor: any active paid plan (or Enterprise) gets the Free 25. Mirrors the
 * API's equipment.controller.js#getCapacityError.
 */
export const canUseEquipment = (orgData) => Boolean(orgData?.isLicensedActive) || isOrgEnterprise(orgData)

/**
 * Equipment is live for the org: on a plan that includes it, and switched on in the
 * org's configs (`hasEquipment` - off unless explicitly true). Budgets only treat
 * equipment lines separately when this is true - otherwise they're plain line items.
 */
export const isEquipmentOn = (orgData) => Boolean(orgData) && orgData.hasEquipment === true && canUseEquipment(orgData)
